import { createRouter, createWebHistory } from "vue-router";
const Layout = () => import("@/layouts/index.vue");
const controlLayouts = () => import("@/controlLayouts/index.vue");
export const routes = [
  {
    path: "/",
    component: Layout,
    redirect: "/login",
    children: [
      {
        path: "/home",
        name: "Home",
        component: () => import("@/views/homePage/index.vue"),
      },
      {
        path: "/event",
        name: "Event",
        component: () => import("@/views/eventPage/index.vue"),
      },
      {
        path: "/analysis",
        name: "Analysis",
        component: () => import("@/views/analysisPage/index.vue"),
      },
      {
        path: "/monitor",
        name: "Monitor",
        component: () => import("@/views/monitorPage/index.vue"),
      },
      {
        path: "/flightList",
        name: "FlightList",
        component: () => import("@/views/flightList/index.vue"),
      },
    ],
  },
  {
    path: "/",
    component: controlLayouts,
    children: [
      {
        path: "/monitor",
        name: "Monitor",
        component: () => import("@/views/monitorPage/index.vue"),
      },
      {
        path: "/flightList",
        name: "FlightList",
        component: () => import("@/views/flightList/index.vue"),
      },
    ],
  },
  {
    path: "/login",
    name: "Login",
    component: () => import("@/views/login/index.vue"),
  },
];
const router = createRouter({
  scrollBehavior: () => ({ left: 0, top: 0 }),
  history: createWebHistory(),
  routes,
});
router.beforeEach((to, from, next) => {
  next();
});
export default router;
